import React from 'react';
import '../../css/layout/Header.scss';
import coffee from '../../image/coffee.png';

const Header = () => {
  return <header className="header">BoxerChoi.Coffee-Break</header>;
};

export default Header;
